import { Divider } from '@mui/material';
import type { ReactNode, RefObject } from 'react';
import { Sheet, SheetRef } from 'react-modal-sheet';

type BottomSheetProps = {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
  ref?: RefObject<SheetRef | null>;
  snapPoints?: number[];
  initialSnap?: number;
  className?: string;
};

export const BottomSheet = ({
  isOpen,
  onClose,
  children,
  ref,
  snapPoints,
  initialSnap,
  className,
}: BottomSheetProps) => {
  return (
    <Sheet
      isOpen={isOpen}
      onClose={onClose}
      ref={ref}
      snapPoints={snapPoints}
      initialSnap={initialSnap}
      className={className}
    >
      <Sheet.Container>
        <Sheet.Header />
        <Divider variant="fullWidth" />
        <Sheet.Content>{children}</Sheet.Content>
      </Sheet.Container>
    </Sheet>
  );
};
